export const { G_CAPTCHA_SITE_KEY } = process.env;
